export const DRIVER_DOCUMENTS = [
  {
    key: "cv",
    uploadField: "CV",
    label: "CV",
  },
  {
    key: "certifiedIdCopy",
    uploadField: "CertifiedIDCopy",
    label: "Certified ID Copy",
    fallbackKeys: ["idCard"],
  },
  {
    key: "certifiedLicenseCopy",
    uploadField: "CertifiedLicenseCopy",
    label: "Certified copy of license",
    fallbackKeys: ["license"],
  },
  {
    key: "proofOfHighestGradePassed",
    uploadField: "ProofOfHighestGradePassed",
    label: "Proof of Highest Grade passed",
  },
  {
    key: "proofOfAddress",
    uploadField: "ProofOfAddress",
    label: "Proof of Address",
    fallbackKeys: ["proofAddress"],
  },
  {
    key: "bankStatementConfirmation",
    uploadField: "BankStatementConfirmation",
    label: "Bank Statement / Confirmation",
  },
  {
    key: "taxNumber",
    uploadField: "TaxNumber",
    label: "Tax number",
  },
  {
    key: "preInterviewQuestionnaire",
    uploadField: "PreInterviewQuestionnaire",
    label: "Pre Interview Questionnaire",
  },
  {
    key: "driversTheoreticalEvaluation",
    uploadField: "DriversTheoreticalEvaluation",
    label: "Drivers Theoretical Evaluation",
  },
  {
    key: "driversPracticalEvaluation",
    uploadField: "DriversPracticalEvaluation",
    label: "Drivers Practical Evaluation",
  },
  {
    key: "intermittentContract",
    uploadField: "IntermittentContract",
    label: "Intermittent Contract",
  },
  {
    key: "useOfCompanyVehiclePolicy",
    uploadField: "UseOfCompanyVehiclePolicy",
    label: "Use of Company Vehicle Policy",
  },
  {
    key: "sop",
    uploadField: "SOP",
    label: "SOP",
  },
  {
    key: "annextures",
    uploadField: "Annextures",
    label: "Annextures",
  },
  {
    key: "nextOfKin",
    uploadField: "NextOfKin",
    label: "Next of Kin",
  },
  {
    key: "criminalCheck",
    uploadField: "CriminalCheck",
    label: "Criminal Check",
  },
  {
    key: "ppe",
    uploadField: "PPE",
    label: "PPE",
  },
  {
    key: "warningDisciplinaries",
    uploadField: "WarningDisciplinaries",
    label: "Warning / Disciplinaries",
    fallbackKeys: ["disaplinary"],
  },
  {
    key: "employeeContactDetails",
    uploadField: "EmployeeContactDetails",
    label: "Employee contact Details",
  },
];
